module.exports = __webpack_public_path__ + "static/media/login.02493c86.jpg";